/* eslint-disable no-unused-vars */
import React, { MouseEvent, CSSProperties, DetailedHTMLProps } from "react";

export interface LabelType
  extends DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  value: string;
  style?: CSSProperties;
  className?: any;
  onClick?: (e: MouseEvent<HTMLInputElement, globalThis.MouseEvent>) => void;
}

const permanentStyle = {
  padding: "2px 0",
  fontSize: "13px",
  width: "auto",
  borderRadius: "4px",
  margin: "0",
  color: "#92959F",
  marginBottom: "5px",
};
export default function Label({ value }: LabelType) {
  return <label style={permanentStyle}>{value}</label>;
}

Label.defaultProps = {
  style: {},
  onClick: () => "",
};
